import type { SubmissionResultSummary } from '@/services/types';

interface SubmissionCaseResultsProps {
  result?: SubmissionResultSummary;
}

export default function SubmissionCaseResults({ result }: SubmissionCaseResultsProps) {
  const cases = result?.caseResults;

  if (!result) {
    return null;
  }

  return (
    <section className='bg-white rounded-2xl p-6 shadow-card-sm'>
      <h2 className='font-semibold text-apple-near-black text-[1.125rem] mb-4'>用例结果</h2>

      {cases && cases.length > 0 ? (
        <div className='space-y-3'>
          {cases.map((item) => (
            <article key={item.index} className='border border-apple-border rounded-xl p-4'>
              <p className='text-[0.8125rem] text-apple-gray mb-2'>用例 #{item.index + 1}</p>
              <p className='text-[0.875rem] text-apple-near-black mb-1'>输入：{item.input}</p>
              <p className='text-[0.875rem] text-apple-near-black mb-1'>期望：{item.expectedOutput}</p>
              <p className='text-[0.875rem] text-apple-near-black mb-1'>实际：{item.actualOutput}</p>
              {item.message ? <p className='text-[0.8125rem] text-red-600 mt-2'>信息：{item.message}</p> : null}
            </article>
          ))}
        </div>
      ) : result.firstFailure ? (
        <article className='border border-apple-border rounded-xl p-4'>
          <p className='text-[0.8125rem] text-apple-gray mb-2'>首个失败用例 #{result.firstFailure.index + 1}</p>
          <p className='text-[0.875rem] text-apple-near-black mb-1'>输入：{result.firstFailure.input}</p>
          <p className='text-[0.875rem] text-apple-near-black mb-1'>期望：{result.firstFailure.expectedOutput}</p>
          <p className='text-[0.875rem] text-apple-near-black mb-1'>实际：{result.firstFailure.actualOutput}</p>
          {result.firstFailure.message ? <p className='text-[0.8125rem] text-red-600 mt-2'>信息：{result.firstFailure.message}</p> : null}
        </article>
      ) : (
        <p className='text-apple-gray text-[0.9375rem]'>接口未返回详细用例列表。</p>
      )}
    </section>
  );
}
